import z from 'zod';

interface Status {
  name: string;
  placeholder: string;
}

interface Inspector {
  name: string;
  image: string;
}

interface Responsible {
  name: string;
  image: string;
}
export interface Vulnerability {
  id: number;
  status: Status;
  order_number: number;
  floor_plan_slug: string;
  floor_plan_name: string;
  criticality: string;
  category: string;
  inspector_data: Inspector;
  responsible_data: Responsible;
  create_date: string;
  last_date: string;
  before_photos: string[];
  after_photos: string[];
  comment: string | null;
  fix_comment: string | null;
  fix_date: string | null;
}

export const completeVulnerabilitySchema = z.object({
  fix_comment: z.string({ required_error: 'Fix comment is required' }).min(1, {
    message: 'Fix comment is required',
  }),
  fix_date: z.string({ required_error: 'Fix date is required' }).min(1, {
    message: 'Fix date is required',
  }),
  photos: z.array(z.instanceof(File)).optional(),
});

export type CompleteVulnerabilityFormValues = z.infer<typeof completeVulnerabilitySchema>;
